import { useState, useCallback, useMemo } from "react";

export interface QrCodeFilters {
  search: string;
  page: number;
  limit: number;
}

export const useQrCodeFilters = () => {
  const [filters, setFilters] = useState<QrCodeFilters>({
    search: "",
    page: 1,
    limit: 25,
  });

  const handleFilterChange = useCallback(
    (key: keyof QrCodeFilters, value: string | number) => {
      setFilters((prev) => ({
        ...prev,
        [key]: value,
        // Reset page when filters change (except when changing page itself)
        ...(key !== 'page' && { page: 1 }),
      }));
    },
    []
  );

  const resetFilters = useCallback(() => {
    setFilters({
      search: "",
      page: 1,
      limit: 25,
    });
  }, []);

  // Memoize query params to prevent unnecessary re-renders
  const queryParams = useMemo(() => {
    const params: Record<string, any> = {
      page: filters.page,
      per_page: filters.limit,
    };
    
    // Add search parameter if not empty
    if (filters.search?.trim()) {
      params.search = filters.search.trim();
    }
    
    return params;
  }, [filters.page, filters.limit, filters.search]);

  return {
    filters,
    queryParams,
    handleFilterChange,
    resetFilters,
  };
}; 